module.exports = __webpack_public_path__ + "img/tab3-2@2x.c6884d5e.png";